
import { useDroppable } from "@dnd-kit/core";
import { Space, Typography, theme } from "antd";
import { useTranslation } from "react-i18next";

const { useToken } = theme;

export function Droppable(props: any) {
  const { t } = useTranslation();
  const { token } = useToken();
  const { setNodeRef, isOver, over } = useDroppable({
    id: props.id,
  });
  const isOverContainer = isOver || (over ? props.children.includes(over.id) : false);
  return (
    <div
      ref={setNodeRef}
      style={{
        textAlign: "center",
        // border: `1px solid ${token.colorBorder}`,
        padding: 5,
        borderRadius: token.borderRadius,
      }}
    >
      <Space direction={'horizontal'} style={{display: 'flex', alignItems: 'center', margin: "8px"}}>
        <Typography.Text>{props.id === "default" ? t("pages.examPeriods.answers") : props.id}:</Typography.Text>
        <div
          style={{
            backgroundColor: isOverContainer ? token.colorBgContainer : token.colorBgContainerDisabled,
            transition: 'background-color .35s ease',
            height: 40,
            width: props.children?.length > 0 ? undefined : 200,
            display: 'flex',
            padding: 5,
            border: props.children?.length > 0 ? 'unset' : `1px solid ${token.colorBorder}`,
            borderRadius: token.borderRadius,
          }}
        >
          <Space>
          {props.children}
          </Space>
         
        </div>
      </Space>
    </div>
  );
}
